import { Col } from 'antd';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { ifClickHandler } from '@lib/events';
import { SonarText } from '@ui/text';
import { PeriscopePardotField, SonarObjectType } from '@sonar-software/sonar-ts-types';
import React, { useMemo } from 'react';
import { SonarRecord, SonarRecordReferences, SonarRecordRow, SonarRecordTags } from '@ui/records';

export type FieldClickHandler = (field: PeriscopePardotField) => void;

export interface PardotFieldProps {
	field: PeriscopePardotField;
	onFieldClick?: FieldClickHandler;
	onParentClick?: FieldClickHandler;
	showParent?: boolean;
	source?: string;
}

export const PardotField: React.FC<PardotFieldProps> = ({ field, onFieldClick, onParentClick, showParent, source }) => {
	const handleFieldClick = useMemo(() => ifClickHandler(onFieldClick, field), [ field, onFieldClick ]);
	const handleParentClick = useMemo(() => ifClickHandler(onParentClick, field), [ field, onParentClick ]);

	return (
		<SonarRecord
			name={ field.displayName }
			onClick={ handleFieldClick }
			onClickParent={ handleParentClick }
			parentName={ showParent ? field.parentDisplayName : '' }
			relatedField={ field.relatedSalesforceDisplayName }
			secondaryInfo={ field.type }
			sonarObjectId={ field.sonarObjectId }
			sonarObjectType={ SonarObjectType.PardotField }
			source={ source }>
			<SonarRecordRow>
				<Col
					className='align-bottom'
					flex='none'>
					<SonarText
						className='custom-item'
						size={ 12 }>
						{ field.isCustom ? COPY_SPECIFIC.CUSTOM : COPY_SPECIFIC.STANDARD }
					</SonarText>
					<SonarRecordReferences
						parentName={ field.parentDisplayName }
						relatedCounts={ field.relatedCounts }
						sonarObjectId={ field.sonarObjectId } />
				</Col>
				<Col flex='auto'>
					<SonarRecordTags sonarObjectId={ field.sonarObjectId } />
				</Col>
			</SonarRecordRow>
		</SonarRecord>
	);
};
